module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.41b2717a.svg";